import React from 'react';
import useEDT from '@teetsh/app/src/queries/edt/useEDT';
import SpinnerComponent from '@teetsh/app/src/components/Spinner/ScreenSpinner';
import EDT from './EDT';
import { Navigate, useParams } from 'react-router-dom';
import { ErrorPage } from 'components/ErrorPage';
import { useUserAccount } from 'queries/user/account/useUserAccount';

export default function EDTDataLoading() {
  const params = useParams<{
    emploiDuTempsId: string;
    schoolyearId: string;
    schoolId: string;
  }>();

  const schoolyearId = params.schoolyearId as string;
  const schoolId = params.schoolId as string;
  const emploiDuTempsId = params.emploiDuTempsId as string;

  const { data, isLoading, isFetched, error } = useEDT({
    edtId: emploiDuTempsId,
    enabled: true,
  });
  const { data: userAccount } = useUserAccount();
  const enableEventTemplate: boolean =
    !!userAccount &&
    userAccount.currentPlan != 'free' &&
    !userAccount.isOnOldPricing;

  if (isLoading || !isFetched) {
    return <SpinnerComponent />;
  }
  if (error?.response?.status === 404) {
    return (
      <Navigate
        to={`/annee-scolaire/${schoolyearId}/ecole/${schoolId}/emploi-du-temps`}
      />
    );
  }
  if (error || !data) {
    return <ErrorPage />;
  }

  return <EDT emploiDuTemps={data} enableEventTemplate={enableEventTemplate} />;
}
